module.exports = __webpack_public_path__ + "img/airbus-logo.9bed4d59.jpg";